
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.RouteDriverOrEquipmentAssigned = {

  template: () => {
      return {
          tag: 'div',
          items: [
              {
                  items: [
                      {
                          items: [
                              {
                                  tag: 'label',
                                  items: [
                                      {
                                          tag: 'span',
                                          html: Monet.I18n.getResourcesByKey('route.DriverOrEquipmentAssigned'),
                                          attributes: {
                                              class: 'i18nResource',
                                              id: 'span-routeDriverOrEquipmentAssigned'
                                          },
                                      },
                                  ],
                                  attributes: {
                                      class: 'control-label',
                                      for: 'routeDriverOrEquipmentAssigned'
                                  }
                              },
                              {
                                  items: [
                                      {
                                          tag: 'select',
                                          attributes: {
                                              multiple: 'true',
                                              id: 'routeDriverOrEquipmentAssigned'
                                          }
                                      }
                                  ],
                                  attributes: {
                                      class: 'controls'
                                  }
                              }
                          ],
                          attributes: {
                              class: 'control-group'
                          }
                      },
                  ]
              }
          ]
      };
  },
  assignParameter: (jsonParam) => {
    const selectField = document.getElementById('routeDriverOrEquipmentAssigned');
    const routeDriverOrEquipmentAssigned = [
      {text: Monet.I18n.getResourcesByKey('event.check.RouteDriverOrEquipmentAssigned.driverAdded') , value: "DRIVER"},
      {text: Monet.I18n.getResourcesByKey('event.check.RouteDriverOrEquipmentAssigned.equipmentAdded'), value: "EQUIPMENT"}
    ];

    const populateEmpty = () => {
      routeDriverOrEquipmentAssigned.forEach((el) => {
        selectField.appendChild(new Option(el.text, el.value, false, false));
      });
    }

    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);

      let isSelected = false;
      let routeDriverOrEquipmentAssignedSelected = jsonParam.assigned;

      if(routeDriverOrEquipmentAssignedSelected && routeDriverOrEquipmentAssignedSelected.length) {
        routeDriverOrEquipmentAssigned.forEach((el) => {
          isSelected = routeDriverOrEquipmentAssignedSelected.includes(el.value);
          selectField.appendChild(new Option(el.text, el.value, false, isSelected));
          isSelected = false;
        });
      } else {
       populateEmpty();
      };
    } else {
      populateEmpty();
    };
  },
  retrieveParameter: () => {
    const routeDriverOrEquipmentAssignedSelected = $('#routeDriverOrEquipmentAssigned').val();

    return JSON.stringify({
      assigned: routeDriverOrEquipmentAssignedSelected || []
    });
  }
};
